import GROUPS_CONSTANTS from "./Customers.constants";
export const GROUP_ID_MAX_LENGTH = 20;
export const GROUP_ID_MIN_LENGTH = 3;

const GROUP_ID_PATTERN = /^[A-Za-z0-9-_]+$/;

export function getGroupIdValidationError(val, groups, idType, existingValue) {
  const trimmedVal = val?.trim() || "";
  let errorMessage = null;
  if (!trimmedVal) {
    errorMessage = GROUPS_CONSTANTS.createGroupErrorMessages.idRequired.replace(
      "{idType}",
      idType
    );
  } else if (trimmedVal.length >= GROUP_ID_MAX_LENGTH) {
    errorMessage =
      GROUPS_CONSTANTS.createGroupErrorMessages.idTooLong.replace(
        "{idType}",
        idType
      );
  }
  else if (trimmedVal.length < GROUP_ID_MIN_LENGTH) {
    errorMessage =
      GROUPS_CONSTANTS.createGroupErrorMessages.idTooShort.replace(
        "{idType}",
        idType
      );
  } else if (!GROUP_ID_PATTERN.test(trimmedVal)) {
    errorMessage = GROUPS_CONSTANTS.createGroupErrorMessages.groupId;
  }
  else if (idType === "Customer ID" && groups?.some((g) => g.code?.toString()?.toLowerCase() === trimmedVal.toLowerCase())) {
    errorMessage = GROUPS_CONSTANTS.createGroupErrorMessages.idDuplicate.replace(
      "{idType}",
      idType
    );
  }
  else if (idType === "Group ID" && trimmedVal !== existingValue && groups?.some((g) => g.groupId?.toString()?.toLowerCase() === trimmedVal?.toLowerCase())) {
    errorMessage = GROUPS_CONSTANTS.createGroupErrorMessages.idDuplicate.replace(
      "{idType}",
      idType
    );
  }
  return errorMessage;
}
